<template>
    <Sheet>  <h2>{{routeTitle}}</h2>


             <el-form :model="model"
                      :rules="rules"
                      label-width="190px"
                      ref="form">
                 <el-form-item label="身份證字號"
                               prop="iDno">
                     <el-input placeholder="請輸入身份證字號"
                               v-model="model.iDno"></el-input>
                 </el-form-item>
                 <el-form-item label="姓名"
                               prop="name">
                     <el-input placeholder="請輸入姓名"
                               v-model="model.name"></el-input>
                 </el-form-item>
                 <el-form-item label="部別"
                               prop="divisName">
                     <el-input placeholder="請輸入部別"
                               v-model="model.divisName"></el-input>
                 </el-form-item>
                 <el-form-item label="學號"
                               prop="studentId">
                     <el-input placeholder="請輸入學號"
                               v-model="model.studentId"></el-input>
                 </el-form-item>
                 <el-form-item label="系所"
                               prop="departmentName">
                     <el-input placeholder="請輸入系所"
                               v-model="model.departmentName"></el-input>
                 </el-form-item>
                 <el-form-item label="班級"
                               prop="className">
                     <el-input placeholder="請輸入班級"
                               v-model="model.className"></el-input>
                 </el-form-item>
                 <el-form-item label="電子郵件"
                               prop="email">
                     <el-input placeholder="請輸入電子郵件"
                               v-model="model.email"></el-input>
                 </el-form-item>
                 <el-form-item label="行動電話"
                               prop="mobiphone">
                     <el-input placeholder="請輸入行動電話"
                               v-model="model.mobiphone"></el-input>
                 </el-form-item>
                 <el-form-item label="戶籍地址"
                               prop="domicile">
                     <el-input placeholder="請輸入戶籍地址"
                               v-model="model.domicile"></el-input>
                 </el-form-item>
                 <el-form-item label="測驗類別"
                               prop="category">
                     <el-select v-model="model.category" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in categoryitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item label="聽力前測等級"
                               prop="lpre_test">
                    <el-input placeholder="請輸入聽力前測等級(Listening Pretest level)"
                               v-model="model.lpre_test"></el-input>
                 </el-form-item>
                  <el-form-item label="閱讀前測等級"
                               prop="rpre_test">
                     <el-input placeholder="請輸入閱讀前測等級(Reading Pretest level)"
                               v-model="model.rpre_test"></el-input>
                 </el-form-item>
                 <el-form-item :label="'前測日期\nPretest date'"
                               prop="pre_date">
                               <el-date-picker
                                placeholder="前測日期(Pretest date)"
                                type="date"
                                v-model="model.pre_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                 <el-form-item label="聽力後測成績"
                               prop="lpost_test">
                     <el-select v-model="model.lpost_test" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in pre_testitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item label="閱讀後測成績"
                               prop="rpost_test">
                      <el-select v-model="model.rpost_test" placeholder="請選擇" tabindex="2">
                         <el-option v-for="item in pre_testitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>
                 </el-form-item>
                 <el-form-item :label="'後測日期\nPosttest date'"
                               prop="post_date">
                               <el-date-picker
                                placeholder="後測日期(Posttest date)"
                                type="date"
                                v-model="model.post_date"
                                format="yyyy-MM-dd"
                                ></el-date-picker>
                 </el-form-item>
                 <el-form-item label="銀行名稱/銀行分行"
                               prop="bankname">
                     <el-input placeholder="請輸入銀行名稱/銀行分行"
                               v-model="model.bankname"></el-input>
                 </el-form-item>
                 <el-form-item label="銀行帳號"
                               prop="bankno">
                     <el-input placeholder="請輸入銀行帳號"
                               v-model="model.bankno"></el-input>
                 </el-form-item>
                 <el-form-item label="曾修習本校華語課程"
                               prop="iS_studyChinese">
                     <el-radio-group v-model="model.iS_studyChinese">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                         注意：若選「否」則不能申請
                     </span>
                 </el-form-item>
                 <el-form-item label="課程名稱"
                               prop="course">
                     <el-input placeholder="請輸入課程名稱"
                               v-model="model.course"></el-input>
                 </el-form-item>
                 <el-form-item label="等級"
                               prop="grade">
                     <el-select v-model="model.grade" placeholder="請選擇" tabindex="2" @change="money()">
                         <el-option v-for="item in gradeitem"
                                    :key="'n'.concat(item.no)"
                                    :label="item.codeName"
                                    :value="item.codeName">
                         </el-option>
                         <el-option key="n00" label="無" :value="0" :disabled="true" />
                     </el-select>

                 </el-form-item>
                 <el-form-item label="申請金額"
                               prop="application_money">
                     <el-input placeholder="申請金額"
                               v-model="model.application_money" :disabled="true"></el-input>
                 </el-form-item>
                 <el-form-item label="申請報名費Apply for registration fee"
                               prop="iS_app_reg_fee">
                     <el-radio-group v-model="model.iS_app_reg_fee">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                     <span style="color:red;">
                         「每人限申請一次」
                     </span>
                 </el-form-item>
                 <el-form-item label="報名費金額"
                               prop="registery_fee">
                     <el-input placeholder="報名費金額"
                               v-model="model.registery_fee" :disabled="model.iS_app_reg_fee==='否'"></el-input>
                 </el-form-item>
                 <el-form-item label="是否通過審核"
                               prop="isReview">
                     <el-radio-group v-model="model.isReview">
                         <el-radio :label="e.value"
                                   v-for="e in yesnos">
                             {{e.label}}
                         </el-radio>
                     </el-radio-group>
                 </el-form-item>
                 <el-form-item label="核定金額"
                               prop="approved_amount">
                     <el-input placeholder="核定金額"
                               v-model="model.approved_amount"></el-input>
                 </el-form-item>
                 <el-form-item label="審核未通過原因"
                               prop="review_content">
                     <el-input placeholder="審核未通過原因"
                               v-model="model.review_content"></el-input>
                 </el-form-item>
                 <el-form-item label="附件" v-if="fileLimit">
                     <el-upload :action="action"
                                :before-remove="handleBeforeRemove"
                                :before-upload="beforeUpload"
                                :data="dataOptions"
                                :headers="uploadHeaders"
                                :limit="4"
                                :on-error="onUploadError"
                                :on-exceed="onExceedLimit"
                                :on-success="onUploadSuccess"
                                ref="upload">
                         <el-button>選擇檔案</el-button>
                         <template #tip>
                             <div class="el-upload__tip">
                                 檔案不超過5MB
                             </div>
                         </template>
                     </el-upload>
                 </el-form-item>
                 <el-button @click="submit"   :disabled="model.iS_studyChinese==='否'">
                     送出
                 </el-button>
             </el-form>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import UploadMixin from '../uploadMixin';

    const defaultModel = {
        idno:'',
        name: '',
        divisName:'',
        studentId:'',
        departmentName:'',
        className:'',
        email: '',
        mobile: '',
        domicile:'',
        category:'',
        lpre_test:'',
        lpost_test:'',
        rpre_test:'',
        rpost_test:'',
        bankname:'',
        bankno:'',
        iS_studyChinese:null,
        course:'',
        grade:'',
        application_money:'0',
        iS_app_reg_fee:null,
        registery_fee:'0',
        isReview:null,
        approved_amount:'0',
        review_content:'',
        uploads: [],
    };
    export default {
        name: 'Form',
        data: () => ({
           categoryitem:null,
           gradeitem:null,
           model: {...defaultModel},
            rules: {
                 name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
               category: [
                    {required: true, message: '請選擇測驗類別', trigger: 'blur'}
                ],
                 lpost_test: [
                    {required: true, message: '請選擇聽力後測等級(Listening Posttest Level)', trigger: 'blur'}
                ],
                 rpost_test: [
                    {required: true, message: '請選擇閱讀後測等級(Reading Posttest Level)', trigger: 'blur'}
                ],
                post_date: [
                    {required: true, message: '請輸入後測日期(Posttest Date)', trigger: 'blur'}
                ],
                course: [
                    {required: true, message: '請輸入課程名稱', trigger: 'blur'}
                ],
                bankname: [
                    {required: true, message: '請輸入銀行名稱/銀行分行', trigger: 'blur'}
                ],
               bankno: [
                    {required: true, message: '請輸入請輸入銀行帳號', trigger: 'blur'}
                ],
              iS_studyChinese: [
                    {required: true, message: '請選擇是否曾修習本校華語課程', trigger: 'blur'}
                ],
             grade: [
                    {required: true, message: '請選擇等級', trigger: 'blur'}
                ],
            application_money: [
                    {required: true, message: '請輸入請輸入申請金額', trigger: 'blur'}
                ],
            iS_app_reg_fee: [
                    {required: true, message: '請選擇是否申請報名費', trigger: 'blur'}
                ],
            },
            url: 'upload',
        }),

        computed: {
            ...mapState('chineseform', ['forms', 'selectedForm']),
            ...mapState('codeDt', ['codeList']),
             yesnos() {
                return [
                     {label: '是(yes)', value: '是'},
                    {label: '否(no)', value: '否'},
                ];
            },
     Review() {
                return [
                    {label: '未審核(Not reviewed)', value: '未審核'},
                    {label: '通過(Pass)', value: '通過'},
                    {label: '未通過(Not Pass)', value: '未通過'},
                ];
            },

        },

        mixins: [routeTitleMixin, UploadMixin],

        methods: {
            ...mapActions('chineseform', {
                insert: 'insertFormAction',
                get: 'getstudFormsAction'
            }),
            ...mapActions('codeDt', {
                getCode: 'getCodeNo',
            }),
            money: function() {

                         if (this.model.grade == "A1-NTD$1800"){
                                     this.model.application_money=1800;
                              }
                           else if (this.model.grade == "A2-NTD$2000")
                           {
                                  this.model.application_money=2000;
                           }
                          else if (this.model.grade == "B1-NTD$2300")
                          {
                                  this.model.application_money=2300;
                          }
                          else if (this.model.grade == "B2-NTD$2500")
                          {
                                 this.model.application_money=2500;
                          }
                          else if (this.model.grade == "C1-NTD$2700")
                          {
                                  this.model.application_money=2700;
                          }
                          else if (this.model.grade == "C2-NTD$3000")
                          {
                                  this.model.application_money=3000;
                          }
                   },
            submit() {

                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {

                        const {success} = await this.insert({
                            ...this.model
                        });
                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                            this.$router.push('/ChineseTable')
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },

            onUploadSuccess(res) {
                this.model.uploads.push(res);
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            }
        },

        watch: {

            selectedForm(current) {

                this.model = {...current};
           }
        },

        async created() {
          var success = await this.getCode(11);

            if (success) {
                         this.categoryitem=success;}
           var pre_testtemp = await this.getCode(12);
         if (pre_testtemp ) {
                         this.pre_testitem=pre_testtemp;}

         var  gradetemp = await this.getCode(13);
    if (gradetemp) {
                         this.gradeitem=gradetemp;}

            this.get();
        }

    }</script>

<style scoped>
.el-form>>>.el-form-item .el-form-item_label{
   white-space: pre-line;
   height: 40px;
   line-height: 20px;
   }
</style>